import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileUploadService, FileUploadResponseData } from '../../services/file-upload.service';
import { GuidService, LocalParserFormatter } from 'core-lib';
import { environment } from '../../../environments/environment';

import * as moment from 'moment';
import { ErrorHandlingService } from 'core-lib';


@Component({
  selector: 'cli-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

  @Input()
  public objectId: string;

  @Input()
  public objectType: string;

  @Input()
  public maxCount = 1000;

  @Input()
  public buttonText = 'Upload Certificate';


  @Input()
  public allowComments = false;

  @Input()
  public isDateShown = false;

  @Input()
  public isUploadButtonShown = true;

  @Output()
  public fileUploaded = new EventEmitter();

  @Output()
  public fileRemoved = new EventEmitter();

  private fileListValue: FileListModel;

  @Input()
  public get fileList(): FileListModel { return this.fileListValue; }
  public set fileList(value: FileListModel) {
    this.fileListValue = value;
    this.initModel();
  }

  public selectedFileNames: string;

  public elementId: string;
  public isDeleting: boolean;
  public fileToDelete: FileListItemModel;

  constructor(private fileUploadSvc: FileUploadService,
    private guidSvc: GuidService,
    private errorHandlingSvc: ErrorHandlingService,
    private formatter: LocalParserFormatter) {

    this.fileList = new FileListModel();

    this.elementId = 'fileUploader' + this.guidSvc.getGuid();
  }

  ngOnInit() {
  }

  private initModel() {
    this.isDeleting = false;
    this.fileToDelete = null;
  }

  public handleFileInput(files: FileList) {

    for (let i = 0; i < files.length; i++) {
      this.upload(files.item(i));
    }

  }



  public upload(f: File): Promise<void> {

    let fm = new FileListItemModel();
    fm.fileName = f.name;
    fm.isRemovable = false;
    fm.isUploading = true;
    fm.dateCreated = moment().toDate();
    this.fileList.items.push(fm);

    let formData = new FormData();
    formData.append('attachment', f);
    formData.append('objectId', this.objectId);
    formData.append('objectType', this.objectType);

    return this.fileUploadSvc.postFile(formData).toPromise().then((data: FileUploadResponseData) => {
      fm.isUploading = false;
      fm.isRemovable = true;

      fm.fileId = data.fileId;
      fm.fileName = data.fileName;
      fm.contentType = data.contentType;
      fm.dateCreated = this.formatter.toDate(this.formatter.fromIsoString(data.dateCreated));

      fm.fullUrl = environment.downloadFileUrl + '/' + fm.fileId;

      this.selectedFileNames = null;

      this.fileUploaded.emit(fm);
    },
      (e) => {

        fm.isUploading = false;

        let index = this.fileList.items.indexOf(fm);
        this.fileList.items.splice(index, 1);

        let msg = this.errorHandlingSvc.processHttpError(e);
        return Promise.reject(msg);
      });
  }

  public downloadFile(f: FileListItemModel) {
    window.open(f.fullUrl + '?token=AAAA', '_blank');
  }

  public editComment(f: FileListItemModel) {
    f.editedCommentText = f.comment;
    f.isEditing = true;
  }

  public saveComment(f: FileListItemModel) {

    this.fileUploadSvc.updateComment(f.fileId, f.editedCommentText).toPromise().then(() => {
      f.comment = f.editedCommentText;
      f.isEditing = false;
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);
        f.isEditing = false;
      });
  }

  public cancelComment(f: FileListItemModel) {
    f.isEditing = false;
  }

  public removeFile(f: FileListItemModel) {
    this.isDeleting = true;
    this.fileToDelete = f;
  }

  public confirmDelete() {

    this.isDeleting = false;

    this.fileUploadSvc.deleteFile(this.fileToDelete.fileId).toPromise().then(() => {
      let index = this.fileList.items.indexOf(this.fileToDelete);
      this.fileList.items.splice(index, 1);

      this.fileRemoved.emit(this.fileToDelete);
      this.fileToDelete = null;
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);
        this.fileToDelete = null;

      });
  }

  public cancelDelete() {
    this.fileToDelete = null;
    this.isDeleting = false;
  }

  public openFileDialog() {
    document.getElementById(this.elementId).click();
  }
}



export class FileListModel {
  constructor() {
    this.items = [];
  }
  public items: FileListItemModel[];
}

export class FileListItemModel {
  public fileId: string;
  public fileName: string;
  public contentType: string;
  public comment: string;
  public dateCreated: Date;
  public fullUrl: string;

  public isRemovable: boolean;
  public isUploading: boolean;
  public isEditing: boolean;

  public editedCommentText: string;
}
export class FileAttachmentDetailsModel {
  public fileId: string;
  public fileName: string;
  public size: number;
  public fullUrl: string;
}
